import { render } from "./HomeItsWhoWeAreComp.vue?vue&type=template&id=fd7ac082&scoped=true"
import script from "./HomeItsWhoWeAreComp.vue?vue&type=script&lang=js"
export * from "./HomeItsWhoWeAreComp.vue?vue&type=script&lang=js"

import "./HomeItsWhoWeAreComp.vue?vue&type=style&index=0&id=fd7ac082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7ac082"]])

export default __exports__